// Types
import { IIndexable } from "types/common";

// Images
import apeSwapIcon from "assets/images/defi/apeswap.png";
import ellipsisIcon from "assets/images/defi/ellipsis.png";
import beefyIcon from "assets/images/defi/beefy.png";
import busdIcon from "assets/images/defi/busd.png";
import deltaIcon from "assets/images/defi/delta.svg";
import openLeverageIcon from "assets/images/defi/openLeverage.png";
import wombatIcon from "assets/images/defi/wombat.svg";
import izumiIcon from "assets/images/defi/izumi.svg";
import aequinoxIcon from "assets/images/defi/aequinox.png";
import impossibleIcon from "assets/images/defi/impossible.svg";
import coneIcon from "assets/images/defi/cone.svg";
import midasLightIcon from "assets/images/defi/midas-light.svg";
import midasDarkIcon from "assets/images/defi/midas-dark.svg";
import kalmyIcon from "assets/images/defi/kalmy.png";
import wombexIcon from "assets/images/defi/wombex.png";
import magpieIcon from "assets/images/defi/magpie.png";
import deriIcon from "assets/images/defi/deri.svg";
import swapFishIcon from "assets/images/defi/swapfish.jpeg";
import thenaIcon from "assets/images/defi/thena.png";
import reaperIcon from "assets/images/defi/reaper-farm.png";

// configs
import { currentNetworkInfo } from "config/network";

export enum PartnerTypes {
  DEX = "dex",
  VAULT = "vault",
  YIELD_OPTIMIZER = "yo",
  LENDING_BORROWING = "lb",
  LEVERAGE_TADING = "lt",
  OPTION_TADING = "ot",
}

export enum Partners {
  APESWAP = "apeswap",
  ELLIPSIS = "ellipsis",
  BEEFY = "beefy",
  BEEFY_ELLIPSIS = "beefyEllipsis",
  BEEFY_APESWAP = "beefyApeswap",
  BEEFY_THENA = "beefyThena",
  DELTA = "delta",
  OPENLEVERAGE = "openLeverage",
  OPENLEVERAGE_LENDING = "openLeverageLending",
  OPENLEVERAGE_TRADING = "openLeverageTrading",
  WOMBAT = "wombat",
  IZUMI = "izumi",
  AEQUINOX = "aequinox",
  IMPOSSIBLE = "impossible",
  CONE = "cone",
  MIDAS = "midas",
  KALMY = "kalmy",
  APESWAP_SD = "apeswapSD",
  WOMBEX = "wombex",
  MAGPIE = "magpie",
  DERI = "deri",
  APESWAP_LENDING = "apeswapLending",
  SWAPFISH = "swapfish",
  THENA = "thena",
  THENA_SD = "thenaSD",
  ELLIPSIS_SD = "ellipsisSD",
  REAPER = "reaper",
  REAPER_THENA = "reaperThena",
}

export const defiIcons: IIndexable = {
  [Partners.APESWAP]: {
    light: apeSwapIcon,
    dark: apeSwapIcon,
  },
  [Partners.ELLIPSIS]: {
    light: ellipsisIcon,
    dark: ellipsisIcon,
  },
  [Partners.BEEFY]: {
    light: beefyIcon,
    dark: beefyIcon,
  },
  [Partners.DELTA]: {
    light: deltaIcon,
    dark: deltaIcon,
  },
  [Partners.OPENLEVERAGE]: {
    light: openLeverageIcon,
    dark: openLeverageIcon,
  },
  [Partners.WOMBAT]: {
    light: wombatIcon,
    dark: wombatIcon,
  },
  [Partners.IZUMI]: {
    light: izumiIcon,
    dark: izumiIcon,
  },
  [Partners.AEQUINOX]: {
    light: aequinoxIcon,
    dark: aequinoxIcon,
  },
  [Partners.IMPOSSIBLE]: {
    light: impossibleIcon,
    dark: impossibleIcon,
  },
  [Partners.CONE]: {
    light: coneIcon,
    dark: coneIcon,
  },
  [Partners.MIDAS]: {
    light: midasLightIcon,
    dark: midasDarkIcon,
  },
  [Partners.KALMY]: {
    light: kalmyIcon,
    dark: kalmyIcon,
  },
  [Partners.WOMBEX]: {
    light: wombexIcon,
    dark: wombexIcon,
  },
  [Partners.MAGPIE]: {
    light: magpieIcon,
    dark: magpieIcon,
  },
  [Partners.DERI]: {
    light: deriIcon,
    dark: deriIcon,
  },
  [Partners.SWAPFISH]: {
    light: swapFishIcon,
    dark: swapFishIcon,
  },
  [Partners.THENA]: {
    light: thenaIcon,
    dark: thenaIcon,
  },
  [Partners.REAPER]: {
    light: reaperIcon,
    dark: reaperIcon,
  },
};

export const defiLabels: IIndexable = {
  [Partners.APESWAP]: "Apeswap",
  [Partners.ELLIPSIS]: "Ellipsis",
  [Partners.BEEFY]: "Beefy",
  [Partners.DELTA]: "delta.theta",
  [Partners.OPENLEVERAGE]: "Open Leverage",
  [Partners.WOMBAT]: "Wombat",
  [Partners.IZUMI]: "Izumi",
  [Partners.AEQUINOX]: "Aequinox",
  [Partners.IMPOSSIBLE]: "Impossible",
  [Partners.CONE]: "Cone",
  [Partners.MIDAS]: "Midas",
  [Partners.KALMY]: "Kalmy",
  [Partners.WOMBEX]: "Wombex",
  [Partners.MAGPIE]: "Magpie",
  [Partners.DERI]: "DERI",
  [Partners.SWAPFISH]: "SwapFish",
  [Partners.THENA]: "Thena",
  [Partners.REAPER]: "Reaper",
};

export const defiUrls: IIndexable = {
  [Partners.APESWAP]: {
    addLiquidity: "https://apeswap.finance/jungle-farms",
    swap: "https://apeswap.finance/swap?inputCurrency=0x1bdd3cf7f79cfb8edbb955f20ad99211551ba275&outputCurrency=0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
  },
  [Partners.APESWAP_SD]: {
    addLiquidity: "https://apeswap.finance/banana-farms",
    swap: "https://apeswap.finance/swap?inputCurrency=0x3bc5ac0dfdc871b365d159f728dd1b9a0b5481e8&outputCurrency=0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
  },
  [Partners.THENA_SD]: {
    addLiquidity:
      "https://thena.fi/liquidity/manage/0x9698e0c7af13B6cEF8017A5c34eb2B3d053C491C",
    swap: "https://thena.fi/swap",
  },
  [Partners.ELLIPSIS]: {
    addLiquidity:
      "https://ellipsis.finance/pool/0xFD4afeAc39DA03a05f61844095A75c4fB7D766DA",
    swap: "https://ellipsis.finance/swap",
  },
  [Partners.ELLIPSIS_SD]: {
    addLiquidity:
      "https://ellipsis.finance/pool/0xF258655f83A7615704d6993c3D968f6679132E45",
    swap: "https://ellipsis.finance/swap",
  },
  [Partners.WOMBAT]: {
    addLiquidity:
      "https://app.wombat.exchange/pool?pool=BNBx&token=BNBx&action=DEPOSIT",
    swap: "https://app.wombat.exchange/swap",
  },
  [Partners.IZUMI]: {
    addLiquidity: "https://izumi.finance/farm/iZi/fix",
    swap: "https://izumi.finance/trade/swap",
  },
  [Partners.IMPOSSIBLE]: {
    addLiquidity:
      "https://app.impossible.finance/liquidity/add/0x1bdd3Cf7F79cfB8EdbB955f20ad99211551BA275/BNB",
    swap: "https://app.impossible.finance/swap",
  },
  [Partners.AEQUINOX]: {
    addLiquidity: "",
    swap: "",
  },
  [Partners.CONE]: {
    addLiquidity:
      "https://www.cone.exchange/liquidity/0xe483f60682a11da3455dfa7912a6eac6176f5797",
    swap: "https://www.cone.exchange/swap",
  },
  [Partners.SWAPFISH]: {
    addLiquidity:
      "https://bsc.swapfish.fi/add/ETH/0x1bdd3Cf7F79cfB8EdbB955f20ad99211551BA275",
    swap: "https://bsc.swapfish.fi/swap",
  },
  [Partners.THENA]: {
    addLiquidity:
      "https://thena.fi/liquidity/manage/0x6c83E45fE3Be4A9c12BB28cB5BA4cD210455fb55",
    swap: "https://thena.fi/swap",
  },
  [Partners.BEEFY_ELLIPSIS]: {
    deposit: "https://app.beefy.com/vault/ellipsis-bnb-bnbx-crypto",
  },
  [Partners.BEEFY_APESWAP]: {
    deposit: "https://app.beefy.com/vault/banana-bnbx-wbnb",
  },
  [Partners.BEEFY_THENA]: {
    deposit: "https://app.beefy.com/vault/thena-bnbx-wbnb",
  },
  [Partners.DELTA]: {
    deposit: "https://app.deltatheta.tech/terminal/BNBx-BUSD",
  },
  [Partners.MIDAS]: {
    supply: "https://app.midascapital.xyz/56/pool/13",
    borrow: "https://app.midascapital.xyz/56/pool/13",
  },
  [Partners.OPENLEVERAGE_LENDING]: {
    supply:
      "https://bnb.openleverage.finance/app/pool/0x00003b7a46599e59228d7083c924b1fe79afdc5e",
  },
  [Partners.APESWAP_LENDING]: {
    supply: "https://lending.apeswap.finance/markets",
    borrow: "https://lending.apeswap.finance/markets",
  },
  [Partners.OPENLEVERAGE_TRADING]: {
    trade: "https://bnb.openleverage.finance/app/trade/pairs/356",
  },
  [Partners.KALMY]: {
    trade: "https://kalmy.app/farm",
  },
  [Partners.WOMBEX]: {
    deposit: "https://wombex.finance/#/bnb/stake",
  },
  [Partners.MAGPIE]: {
    deposit: "https://www.magpiexyz.io/stake",
  },
  [Partners.DERI]: {
    deposit: "https://deri.fi/#/stable-earn",
  },
  [Partners.REAPER_THENA]: {
    deposit: "https://www.reaper.farm/",
  },
};

export const itemGroups = [
  {
    title: "SD pools",
    hasAPY: false,
    isSDPool: true,
    items: [
      {
        id: Partners.APESWAP_SD,
        name: defiLabels[Partners.APESWAP],
        platformIcon: defiIcons[Partners.APESWAP],
        type: PartnerTypes.DEX,
        icon: {
          light: busdIcon,
          dark: busdIcon,
        },
        token: "BUSD",
        showToken: true,
        links: defiUrls[Partners.APESWAP_SD],
      },
      {
        id: Partners.THENA_SD,
        name: defiLabels[Partners.THENA],
        platformIcon: defiIcons[Partners.THENA],
        type: PartnerTypes.DEX,
        icon: currentNetworkInfo.tokenXIcon,
        token: "BNBx",
        showToken: true,
        links: defiUrls[Partners.THENA_SD],
      },
      {
        id: Partners.ELLIPSIS_SD,
        name: defiLabels[Partners.ELLIPSIS],
        platformIcon: defiIcons[Partners.ELLIPSIS],
        type: PartnerTypes.DEX,
        icon: {
          light: busdIcon,
          dark: busdIcon,
        },
        token: "BUSD",
        showToken: true,
        links: defiUrls[Partners.ELLIPSIS_SD],
      },
    ],
  },
  {
    title: "Liquidity pools",
    hasAPY: false,
    items: [
      {
        id: Partners.APESWAP,
        name: defiLabels[Partners.APESWAP],
        platformIcon: defiIcons[Partners.APESWAP],
        type: PartnerTypes.DEX,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        showToken: true,
        links: defiUrls[Partners.APESWAP],
      },
      {
        id: Partners.ELLIPSIS,
        name: defiLabels[Partners.ELLIPSIS],
        platformIcon: defiIcons[Partners.ELLIPSIS],
        type: PartnerTypes.DEX,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        showToken: true,
        links: defiUrls[Partners.ELLIPSIS],
      },
      {
        id: Partners.WOMBAT,
        name: defiLabels[Partners.WOMBAT],
        platformIcon: defiIcons[Partners.WOMBAT],
        type: PartnerTypes.DEX,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        showToken: false,
        links: defiUrls[Partners.WOMBAT],
      },
      // {
      //   id: Partners.IZUMI,
      //   name: defiLabels[Partners.IZUMI],
      //   platformIcon: defiIcons[Partners.IZUMI],
      //   type: "dex",
      //   icon: tokenIcon,
      //   token: "BNB",
      //   showToken: true,
      //   links: defiUrls[Partners.IZUMI],
      // },
      // {
      //   id: Partners.IMPOSSIBLE,
      //   name: defiLabels[Partners.IMPOSSIBLE],
      //   platformIcon: defiIcons[Partners.IMPOSSIBLE],
      //   type: PartnerTypes.DEX,
      //   icon: currentNetworkInfo.icon,
      //   token: "BNB",
      //   showToken: true,
      //   links: defiUrls[Partners.IMPOSSIBLE],
      // },
      {
        id: Partners.CONE,
        name: defiLabels[Partners.CONE],
        platformIcon: defiIcons[Partners.CONE],
        type: PartnerTypes.DEX,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        showToken: true,
        links: defiUrls[Partners.CONE],
      },
      {
        id: Partners.SWAPFISH,
        name: defiLabels[Partners.SWAPFISH],
        platformIcon: defiIcons[Partners.SWAPFISH],
        type: PartnerTypes.DEX,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        showToken: true,
        links: defiUrls[Partners.SWAPFISH],
      },
      {
        id: Partners.THENA,
        name: defiLabels[Partners.THENA],
        platformIcon: defiIcons[Partners.THENA],
        type: PartnerTypes.DEX,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        showToken: true,
        links: defiUrls[Partners.THENA],
      },
    ],
  },
  {
    title: "Vaults",
    hasAPY: false,
    items: [
      {
        id: Partners.DERI,
        name: defiLabels[Partners.DERI],
        platformIcon: defiIcons[Partners.DERI],
        type: PartnerTypes.VAULT,
        icon: {
          light: busdIcon,
          dark: busdIcon,
        },
        token: "BUSD",
        showToken: true,
        links: defiUrls[Partners.DERI],
      },
    ],
  },
  {
    title: "Yield optimizers",
    hasAPY: true,
    items: [
      {
        id: Partners.BEEFY_ELLIPSIS,
        name: defiLabels[Partners.BEEFY],
        platformIcon: defiIcons[Partners.BEEFY],
        type: PartnerTypes.YIELD_OPTIMIZER,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        links: defiUrls[Partners.BEEFY_ELLIPSIS],
        pair: {
          name: defiLabels[Partners.ELLIPSIS],
          icon: defiIcons[Partners.ELLIPSIS],
        },
      },
      {
        id: Partners.BEEFY_APESWAP,
        name: defiLabels[Partners.BEEFY],
        platformIcon: defiIcons[Partners.BEEFY],
        type: PartnerTypes.YIELD_OPTIMIZER,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        links: defiUrls[Partners.BEEFY_APESWAP],
        pair: {
          name: defiLabels[Partners.APESWAP],
          icon: defiIcons[Partners.APESWAP],
        },
      },
      {
        id: Partners.BEEFY_THENA,
        name: defiLabels[Partners.BEEFY],
        platformIcon: defiIcons[Partners.BEEFY],
        type: PartnerTypes.YIELD_OPTIMIZER,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        links: defiUrls[Partners.BEEFY_THENA],
        pair: {
          name: defiLabels[Partners.THENA],
          icon: defiIcons[Partners.THENA],
        },
      },
      {
        id: Partners.WOMBEX,
        name: defiLabels[Partners.WOMBEX],
        platformIcon: defiIcons[Partners.WOMBEX],
        type: PartnerTypes.YIELD_OPTIMIZER,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        links: defiUrls[Partners.WOMBEX],
        pair: {
          name: defiLabels[Partners.WOMBAT],
          icon: defiIcons[Partners.WOMBAT],
        },
      },
      {
        id: Partners.MAGPIE,
        name: defiLabels[Partners.MAGPIE],
        platformIcon: defiIcons[Partners.MAGPIE],
        type: PartnerTypes.YIELD_OPTIMIZER,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        links: defiUrls[Partners.MAGPIE],
        pair: {
          name: defiLabels[Partners.WOMBAT],
          icon: defiIcons[Partners.WOMBAT],
        },
      },
      {
        id: Partners.REAPER_THENA,
        name: defiLabels[Partners.REAPER],
        platformIcon: defiIcons[Partners.REAPER],
        type: PartnerTypes.YIELD_OPTIMIZER,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        links: defiUrls[Partners.REAPER_THENA],
        pair: {
          name: defiLabels[Partners.THENA],
          icon: defiIcons[Partners.THENA],
        },
      },
    ],
  },
  {
    title: "Lending & borrowing",
    hasAPY: true,
    items: [
      {
        id: Partners.OPENLEVERAGE_LENDING,
        name: defiLabels[Partners.OPENLEVERAGE],
        platformIcon: defiIcons[Partners.OPENLEVERAGE],
        type: PartnerTypes.LENDING_BORROWING,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        links: defiUrls[Partners.OPENLEVERAGE_LENDING],
      },
      {
        id: Partners.MIDAS,
        name: defiLabels[Partners.MIDAS],
        platformIcon: defiIcons[Partners.MIDAS],
        type: PartnerTypes.LENDING_BORROWING,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        links: defiUrls[Partners.MIDAS],
      },
      {
        id: Partners.APESWAP_LENDING,
        name: defiLabels[Partners.APESWAP],
        platformIcon: defiIcons[Partners.APESWAP],
        type: PartnerTypes.LENDING_BORROWING,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        links: defiUrls[Partners.APESWAP_LENDING],
      },
    ],
  },
  {
    title: "Leverage farming",
    hasAPY: true,
    items: [
      {
        id: Partners.KALMY,
        name: defiLabels[Partners.KALMY],
        platformIcon: defiIcons[Partners.KALMY],
        type: PartnerTypes.LEVERAGE_TADING,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        links: defiUrls[Partners.KALMY],
      },
      {
        id: Partners.OPENLEVERAGE_TRADING,
        name: defiLabels[Partners.OPENLEVERAGE],
        platformIcon: defiIcons[Partners.OPENLEVERAGE],
        type: PartnerTypes.LEVERAGE_TADING,
        icon: currentNetworkInfo.icon,
        token: "BNB",
        links: defiUrls[Partners.OPENLEVERAGE_TRADING],
        apyMessage: "APY is computed based on 6x Leverage long position",
      },
    ],
  },
  {
    title: "Options trading & vaults",
    hasAPY: false,
    items: [
      {
        id: Partners.DELTA,
        name: defiLabels[Partners.DELTA],
        platformIcon: defiIcons[Partners.DELTA],
        type: PartnerTypes.OPTION_TADING,
        icon: {
          light: busdIcon,
          dark: busdIcon,
        },
        token: "BUSD",
        links: defiUrls[Partners.DELTA],
      },
    ],
  },
];
